/* PW v94.6 punch (14 Oct). Product page only, runs when .pw-pdp--punch is on the page.
   1. Thumbnail strip follows the main image.
   2. Live preview: the personalization canvas (any preview script) sits right under the name and year
      fields, centered, about 250px tall, caption "Live preview". It updates as they type because it is
      the preview script's own canvas, only moved. Overflow pass: the gallery overlay copy is gone.
   3. Sticky bar shows only once the main Add to cart has scrolled above the screen.
   4. Express checkout waits for the personalization: an empty field sends the tap to the Add to cart gate,
      which scrolls to the field and names it. */
(function () {
  function q(s, c) { return (c || document).querySelector(s); }
  function init() {
    var root = q('.pw-pdp--punch');
    if (!root || root.dataset.pwPunch) return;
    root.dataset.pwPunch = '1';
    var form = q('[data-pw-form]', root), atc = q('[data-pw-atc]', root);

    /* 1 thumbnail strip: scroll only the strip, never the page */
    var rail = q('.pw-gal__rail', root);
    if (rail && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (rail.scrollWidth <= rail.clientWidth + 2) return;
        var th = rail.querySelector('[aria-current="true"]');
        if (!th) return;
        var l = Math.max(0, th.offsetLeft - (rail.clientWidth - th.offsetWidth) / 2);
        try { rail.scrollTo({ left: l, behavior: 'smooth' }); } catch (e) { rail.scrollLeft = l; }
      }).observe(rail, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
    }

    /* 3 sticky bar after the button */
    var bar = q('[data-pw-stickybar]', root);
    if (bar && atc) {
      var tick = false;
      var upd = function () { tick = false; bar.classList.toggle('pw-past', atc.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }

    /* 4 express checkout gate */
    if (form && atc) {
      window.addEventListener('click', function (e) {
        var t = e.target, pb = t && t.closest ? t.closest('.shopify-payment-button') : null;
        if (!pb || !form.contains(pb)) return;
        var fs = [].slice.call(form.querySelectorAll('[data-pw-mky-input], input[data-pw-pers][required], select[required]'));
        var empty = fs.filter(function (f) {
          return !f.disabled && f.type !== 'hidden' && (f.offsetParent !== null || f.matches('[data-pw-mky-input]')) && !String(f.value || '').trim();
        })[0];
        if (!empty) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        atc.click();
      }, true);
    }

    /* 2 live preview right under the fields */
    var mky = q('[data-pw-mky]', root);
    if (!mky) return;
    var t0 = Date.now();
    function place() {
      var cv = mky.querySelector('canvas');
      if (!cv) { if (Date.now() - t0 < 8000) setTimeout(place, 250); return; }
      var fig = cv.closest('figure');
      if (!fig || !mky.contains(fig)) {
        fig = cv.parentNode;
        if (fig === mky) {
          fig = document.createElement('figure');
          mky.insertBefore(fig, cv);
          fig.appendChild(cv);
        }
      }
      fig.classList.add('pw-live', 'pw-live--punch');
      var fields = mky.querySelectorAll('.pw-mky__field');
      var last = fields[fields.length - 1];
      if (last && !fig.contains(last) && last.nextElementSibling !== fig) last.parentNode.insertBefore(fig, last.nextSibling);
      if (!fig.querySelector('.pw-livecap')) {
        var c = document.createElement('p');
        c.className = 'pw-livecap';
        c.textContent = 'Live preview';
        fig.appendChild(c);
      }
      if (!cv.getAttribute('aria-label')) { cv.setAttribute('role', 'img'); cv.setAttribute('aria-label', 'Live preview of your personalization'); }
    }
    place();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
